import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-conf',
  templateUrl: './conf.component.html',
  styleUrls: ['./conf.component.css']
})
export class ConfComponent implements OnInit {

  constructor(private auth:AuthService, private utl:UtilitiesService, private toastr:ToastrManager) { }

  ngOnInit() {
  }

  async changePassword(event) : Promise<void> {
    event.preventDefault();
    
    var actual_password:string = event.target.querySelector('#actual_password').value;
    var password:string = event.target.querySelector('#password').value;
    var password_confirmation:string = event.target.querySelector('#password_confirmation').value;

    if(!actual_password || !password || !password_confirmation) {
      this.toastr.infoToastr("Todos los campos son obligatorios");
      return;
    }

    try {
      await this.auth.changePassword(actual_password, password, password_confirmation);

      event.target.querySelector('#actual_password').value = "";
      event.target.querySelector('#password').value = "";
      event.target.querySelector('#password_confirmation').value = "";

      this.toastr.successToastr("Password changed correctly");
      this.auth.logout();
    } catch(e) {
      if(e.status == 401 || e.status == 401) {
        this.toastr.errorToastr(e.error.message);
      } else {
        this.toastr.errorToastr('Error al cambiar el password');
      }
    }
  }

}
